import TextEditor from "@/shared/widgets/text-editor";
import { Label } from "@/shared/ui/label";

interface Props {
    value: string;
    onChange: (index: number, key: string, value: string) => void;
    index: number;
    validationError?: string;
    clearFieldError?: (field: string) => void;
}
export const TextContentInput: React.FC<Props> = ({ value, onChange, index, validationError, clearFieldError }) => (
    <div className="space-y-2">
        <Label className="text-white text-sm">
            Texto
        </Label>
        <div className={`border rounded-md ${validationError ? 'border-red-500' : 'border-[#333333]'}`}>
            <TextEditor
                value={value}
                onChange={(value) => {
                    onChange(index, 'value', value);
                    clearFieldError?.(`contents.${index}.value`);
                }}
                placeholder="Comece a escrever seu texto..."
                className="min-h-[300px]"
            />
        </div>
        {validationError && (
            <p className="text-red-500 text-sm mt-1">{validationError}</p>
        )}
    </div>
);
